export default {
  'Choose File': 'Scegli File',
  'Please paste a URL': 'Si prega di incollare un URL',
  'Loading': 'Caricamento in corso',
  'Analyzing': 'Analisi in corso',
  'Try a sample': 'Prova un esempio',
  'Sorry, error occurs when analyzing the URL.': "SCi spiace, si verifica un errore nel corso dell'analisi dell'URL.",
}